// extracted by mini-css-extract-plugin
var _1 = "sTj4grI8";
var _2 = "sTj4grI8";
export { _1 as "store-info__actions", _2 as "storeInfoActions" }
